import React from "react";

import { makeStyles } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import BuildIcon from "@material-ui/icons/Build";
import MenuIcon from "@material-ui/icons/Menu";
import PropTypes from "prop-types";

import ConfigModal from "./ConfigModal";

const useStyles = makeStyles(
  ({ breakpoints, palette: { primary, type, grey, custom } }) => ({
    root: {
      display: "flex",
      alignItems: "center",
      height: "100%",
      background: type === "dark" ? custom.bg[50] : primary.main,
    },
    menuArea: {
      display: "flex",
      justifyContent: "center",
      width: 60,
    },
    menu: {
      color: type === "dark" ? grey[100] : primary.contrastText,
    },
    titleArea: {
      flexGrow: 1,
      width: 1,
      fontSize: "1.2rem",
      opacity: type === "dark" ? 0.46 : 0.92,
      textTransform: "uppercase",
      color: type === "dark" ? grey[100] : primary.contrastText,
      [breakpoints.up("lg")]: {
        padding: 20,
      },
    },
    actionsArea: {
      position: "relative",
      paddingLeft: 16,
    },
    action: {
      color: type === "dark" ? grey[200] : primary.contrastText,
      opacity: 0.8,
      background: type === "dark" ? custom.bg[300] : "rgba(255, 255, 255, 0.1)",
      marginLeft: 8,
    },
    avatarArea: {
      display: "flex",
      justifyContent: "center",
      width: 52,
    },
    avatar: {
      background: type === "dark" ? primary.main : undefined,
      color: type === "dark" ? primary.contrastText : custom.low,
      border: `1px solid ${custom.border[600]}`,
    },
  })
);

function MainHeader(props) {
  const { onOpenMenu } = props;
  const classes = useStyles();
  const [configOpen, setConfigOpen] = React.useState(false);

  const handleOpenConfig = () => {
    setConfigOpen(true);
  };

  const handleCloseConfig = () => {
    setConfigOpen(false);
  };

  return (
    <div className={classes.root}>
      <Hidden lgUp>
        <div className={classes.menuArea}>
          <MenuIcon className={classes.menu} onClick={onOpenMenu} />
        </div>
      </Hidden>
      <div className={classes.titleArea}>
        <Typography noWrap>React Enterprise Template</Typography>
      </div>
      <div className={classes.actionsArea}>
        <IconButton
          className={classes.action}
          aria-label="Configuration"
          onClick={handleOpenConfig}
        >
          <BuildIcon fontSize="small" />
        </IconButton>
      </div>
      <div className={classes.avatarArea}>
        <Avatar className={classes.avatar}>RB</Avatar>
      </div>
      <ConfigModal open={configOpen} onClose={handleCloseConfig} />
    </div>
  );
}

MainHeader.propTypes = {
  onOpenMenu: PropTypes.func.isRequired,
};

MainHeader.defaultProps = {};

export default React.memo(MainHeader);
